//17th sep code start
// let allInputs =  document.querySelectorAll('.card-product-item input');
// let selectText = document.querySelector('.please-select-txt');

// const allUnchecked = Array.from(allInputs).every(checkbox => !checkbox.checked);

$('#expBtn span').click(function(){   
    let btnAttr = $('#expBtn').attr("disabled");    
    if( btnAttr == 'disabled' ){      
     $('#popId').addClass('showPop');   
    }else{      
      $('#popId').removeClass('showPop');
    }  
})

$('#popId').find('.clsBtn').click(function(){
    $('#popId').removeClass('showPop');  
   $('html, body').animate({
        scrollTop: $('#adventure_section').offset().top
    }, 100); // 1000ms = 1 second for smooth scrolling
  })



//product page badge

// let badgeWrapper = document.querySelector('.prd_bdg');
// let allBadges =  badgeWrapper.querySelectorAll('.bdg_gd');

// allBadges.forEach(badge =>{
//   badge.addEventListener('click',()=>{
    
//   })
// })

// console.log(allBadges)

//17th sep code end






var base_url = window.location.href;

const urlParams = new URL(base_url).searchParams;
const parItems = [];

urlParams.forEach((value, key) => {
  if (key.startsWith('item')) {
    parItems.push(value);
  }
});

$(document).ready(function(){
  let strValues = [];  
  $(".card-product-item input").change(function(){
    let thisVal = $(this).attr("data-pack");

    if ($(this).is(':checked')) {
      strValues.push(thisVal);
    } else {
      var indexx = strValues.indexOf(thisVal);
      if (indexx > -1) {
        strValues.splice(indexx, 1);
      }
    }
    
    if (strValues.length === 1) {       
      let thisVariant = $(this).parents(".cnt").find(".card-pro-variants").find("input#solo-bundle");
      $(thisVariant).click();
      $(".proPriceBtns").find("input").attr("data-var-val", $(thisVariant).val());
      $(".proPriceBtns .discounted").hide();
      $(".selectAnother").show();
      // $(".proPriceBtns .discounted").text("Select another pack to unlock savings");
    } 
    else if (strValues.length === 2) {    
      let thisVariant = $(this).parents(".cnt").find(".card-pro-variants").find("input#duo-bundle");
      $(thisVariant).click();
      $(".proPriceBtns .discounted").show();
      $(".selectAnother").hide();      
      $(".proPriceBtns").find("input").attr("data-var-val", $(thisVariant).val());      
      $(".proPriceBtns .discounted span").text($(thisVariant).attr("data-discount"));
    } 
    else if (strValues.length === 3){
      let thisVariant = $(this).parents(".cnt").find(".card-pro-variants").find("input#trio-bundle");
      $(thisVariant).click();
      $(".proPriceBtns").find("input").attr("data-var-val", $(thisVariant).val());  
      $(".proPriceBtns .discounted span").text($(thisVariant).attr("data-discount"));
    } 
    else if (strValues.length === 4){
      let thisVariant = $(this).parents(".cnt").find(".card-pro-variants").find("input#complete-bundle");
      $(thisVariant).click();
      $(".proPriceBtns").find("input").attr("data-var-val", $(thisVariant).val());  
      $(".proPriceBtns .discounted span").text($(thisVariant).attr("data-discount"));
    } 

    let packValues = strValues.join("/") + " Combo";

    $(".selectedValues").text(strValues.join("/") + " Combo");

    if(strValues.length >= 1) {
      $(".goToProduct").prop("disabled", false);
      $(".selectedCombo").show();
      // $(".discounted").show();
    } else {
       
      $(".goToProduct").attr("disabled", true);
     
      $(".selectedCombo").hide();
      $(".discounted").hide();
      $(".selectAnother").hide();
    }

  })

  $(".goToProduct").click(function(){
    
    //17sep code
    
    let finalResult = '';
    strValues.forEach((item, index) => {
      finalResult += `item${index + 1}=${item}`;
      if (index < strValues.length - 1) {
        finalResult += '&';
      }
    });    

    originURL = $(".dataCont").attr("data-origin-url"); 
    constructedURL = $(".dataCont").attr("data-base-url"); 
    selectedVariant = $(".dataCont").attr("data-var-val"); 
    window.location.href = originURL + "/" + constructedURL + "?variant=" + selectedVariant + "&" + finalResult;     
  });

  // menu sticky if banner
  if($('.shopify-section').hasClass('common_innerPgbanner')){
    $('.shopify-section-group-header-group').addClass('backgroundTrans');
  };
  
  
});

if(document.querySelectorAll('#itemList li').length >= 1){
document.addEventListener('DOMContentLoaded', (event) => {
  
  if (base_url.indexOf("products") !== -1) {

    const itemList = document.getElementById('itemList');
    const selectedCountElement = document.getElementById('selectedCount');
    const selectedItemsElement = document.querySelectorAll('.appendData');
    

    itemList.addEventListener('click', function(event) {
      const item = event.target.closest('li');
      if (!item || !itemList.contains(item)) return;

      // Bundle Product page: product-bundle-script owns active/selected state.
      // Avoid double-toggle which blocks re-select.
      if (window.__impetroBundlePacksBound) {
        setTimeout(function () {
          updateSelectedItems();
          if (typeof window.syncInsidePackageFromIncludedPacks === 'function') {
            window.syncInsidePackageFromIncludedPacks();
          }
        }, 0);
        return;
      }

      item.classList.toggle('selected');
      updateSelectedItems();
      if (typeof window.syncInsidePackageFromIncludedPacks === 'function') {
        window.syncInsidePackageFromIncludedPacks();
      }
    });

    
    function updateSelectedItems() {
      const selectedItems = document.querySelectorAll('#itemList .selected');
      const selectedCount = selectedItems.length;
      
      document.querySelectorAll('.dataTitle span').forEach(function(e,i){
        e.textContent = selectedCount
      })
      
      
      // Update selected count text
      // if (selectedCount === 1) {       
      //   document.querySelector('#varientItem1 label').click();      
      // } else if (selectedCount === 2) {
      //   document.querySelector('#varientItem2 label').click();             
      // } else if (selectedCount === 3){
      //   document.querySelector('#varientItem3 label').click();                   
      // } else if (selectedCount === 4){
      //   document.querySelector('#varientItem4 label').click(); 

      // }

  
      // Update selected items list
     
      for( i=0; selectedItemsElement.length > i; i++ ){
        
        
      selectedItemsElement[i].innerHTML = ''; // Clear the current list
      selectedItems.forEach(item => {        
        const li = document.createElement('li');
        li.textContent = item.textContent;
        selectedItemsElement[i].appendChild(li);
      });
      }
    }
        let bestOffer = document.createElement('span');
        bestOffer.innerHTML = "Best Offer";
        const varientItem4 = document.querySelector('#varientItem4');
        if (varientItem4) {
          varientItem4.prepend(bestOffer);
          bestOffer.classList.add('bstOfr');
        }
    if(parItems.length > 0) {
      $('#itemList .typItem').each(function(index, element) {
        const itemText = $(element).text().trim();
        if (parItems.includes(itemText)) {
          $(element).click(); 
        }
      });

      setTimeout(function(){
        if(parItems.length === 1) {
          document.querySelector('#varientItem1 label').click();      
        } else if (parItems.length === 2) {
          document.querySelector('#varientItem2 label').click();             
        } else if (parItems.length === 3){
          document.querySelector('#varientItem3 label').click();                   
        } else if (parItems.length === 4){
          document.querySelector('#varientItem4 label').click();                   
        }        
      }, 300);        
      
    } 
    else {
      itemList.querySelector(".typItem").click();   
    }  
    
  }

  
    
  
});
}


// add remove active class
$('.varientList li label').click(function(i,e){
   $('.varientList li').removeClass('active');
   $(this).parents('li').addClass('active');
   setTimeout(function(){
     let priceTxt = $('.product__info-wrapper .price__sale .price-item--last').text();          
     $('#priceBtn span').text(priceTxt);     
       setValue();
   }, 1000);
   
})

// product sticky bar append title and image
function setValue(){
 let valtitle = $('.varientList li.active').find('label').attr('title');
  let valImge = $('.varientList li.active').find('label').attr('data-src');
  $('#imageBox').find('img').attr('src', valImge);
  $('#titleProd').text(valtitle);
}


// after click complete bundle select all items ******

function show4box(){
   $('#itemList .typItem').addClass('selected');
    $('.varientList li:last-child .appendData').html(' ');
  $('#itemList .typItem').each(function(i,e){
   let item = "<li>"+ $(e).text() +"</li>";
    $('.varientList li:last-child .appendData').append(item);    
  })
  sltFun();
}
$('.varientList li:last-child label').click(function(){
   show4box();
    sltFun();  
})


// on load complete bundle select
let urlLink = location.href;
let detailsLink = urlLink.split('&')[1];  
if(detailsLink == undefined ){  
  $(document).ready(function(){
    $('.varientList li:last-child label').click();    
  })  
}                    


// end code


// product details add to cart

function getBundlePackProperties() {
  const properties = {};
  const packArr = [];

  // Shopify Pack 1–3 dropdown selections
  if (window.bundleDropdownSelections) {
    const sels = window.bundleDropdownSelections;
    [1, 2, 3].forEach(function (i) {
      if (sels[i]) {
        properties['Pack ' + i] = sels[i];
        packArr.push(sels[i]);
      }
    });
  }

  // Metafield pack product variant selections — stored on the parent line
  if (window.metafieldPackSelections) {
    Object.keys(window.metafieldPackSelections).forEach(function (key) {
      const sel = window.metafieldPackSelections[key];
      if (sel && sel.title) {
        const label = sel.productTitle || ('Pack ' + (Number(key) + 1));
        const priceLabel = typeof sel.price === 'number'
          ? ' — ' + (sel.price / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' })
          : '';
        properties[label] = sel.title + priceLabel;
        packArr.push(sel.title);
      }
    });
  }

  // Chip / typItem UI (other bundle templates)
  if (!packArr.length) {
    $('#itemList .typItem.selected').each(function () {
      packArr.push($(this).text());
    });
  }

  let base = $('.baseItem .typItem').text();
  if (base) packArr.unshift(base);

  if (packArr.length) {
    properties['Selected Packs'] = packArr.join(', ');
  }

  return properties;
}

function getBundleCartItems(qty) {
  const parentId = document.querySelector('input.product-variant-id').value;
  const quantity = qty || 1;
  const bundleId = 'bundle_' + Date.now();
  const parentProperties = getBundlePackProperties();
  parentProperties['_bundle_id'] = bundleId;

  // Pack products stay linked under the parent: one visible parent line in cart UI,
  // components carry the pack prices so the combined total is charged correctly.
  const items = [
    {
      id: Number(parentId),
      quantity: quantity,
      properties: parentProperties
    }
  ];

  if (window.metafieldPackSelections) {
    Object.keys(window.metafieldPackSelections).forEach(function (key) {
      const sel = window.metafieldPackSelections[key];
      if (sel && sel.variantId) {
        items.push({
          id: Number(sel.variantId),
          quantity: quantity,
          properties: {
            '_bundle_id': bundleId,
            '_bundle_parent': String(parentId),
            '_bundle_component': '1'
          }
        });
      }
    });
  }

  return items;
}

function addCrt(prodId, qty) {
  const cartDrawer = document.querySelector('cart-drawer');
  const proData = {
    items: getBundleCartItems(qty),
    sections: cartDrawer
      ? Array.from(cartDrawer.getSectionsToRender()).map(section => section.id)
      : undefined,
    sections_url: window.location.pathname
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(proData)
  })
    .then(response => {
      if (!response.ok) {
        return response.json().then(errorData => {
          throw new Error(JSON.stringify(errorData));
        });
      }
      return response.json();
    })
    .then(data => {
      if (cartDrawer) {
        cartDrawer.renderContents(data);
        cartDrawer.classList.remove('is-empty');
        setTimeout(() => {
          cartDrawer.open();
        }, 750);
      }
    })
    .catch(error => {
      console.log(error);
    });
}

function addCheck() {
  const items = getBundleCartItems(1);

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ items: items })
  })
    .then(response => {
      if (!response.ok) {
        return response.json().then(errorData => {
          throw new Error(JSON.stringify(errorData));
        });
      }
      window.location.href = '/checkout';
    })
    .catch(error => {
      console.log(error);
    });
}

// product type icon wrap
$('#itemList li').each(function(i,e){
  let icon = `#icon${i+1}`;
  let iconSpn = $('#itemList').find(icon);
  $(e).prepend(iconSpn);
  
})


// product price append
$(window).scroll(function(){
  priceUpdate();
})

function priceUpdate() {
  let priceTxt = $('.product__info-wrapper .price__sale .price-item--last').text();
  $('#priceBtn span').text(priceTxt);
}


  document.querySelectorAll('.video_Item .videoWrap').forEach(function(item) {
    item.addEventListener('click', function() {
      this.classList.toggle('clicked');
      var video = this.closest('.video_Item').querySelector('video');
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });
  });
  
  document.querySelectorAll('.video_Item .vid_item').forEach(function(item) {
    item.addEventListener('ended', function() {
      this.closest('.videoWrap').classList.remove('clicked');
    });
  });


function normalizeInsidePackKey(label) {
  if (!label) return '';
  var s = String(label).toLowerCase().replace(/[_-]+/g, ' ').trim();
  var keys = ['mountain', 'hike', 'bike', 'ski', 'trek', 'base'];
  for (var i = 0; i < keys.length; i++) {
    if (s === keys[i] || s.indexOf(keys[i]) !== -1) {
      return keys[i] === 'base' ? 'base_unit' : keys[i];
    }
  }
  return '';
}

function getSelectedIncludedPackKeys() {
  var selectedKeys = [];
  $('#itemList .typItem.selected, #itemList .typItem.active, .boxTyp .typItem.selected, .boxTyp .typItem.active').each(function () {
    var key = normalizeInsidePackKey($(this).text());
    if (key && selectedKeys.indexOf(key) === -1) selectedKeys.push(key);
  });
  // Bundle dropdown Pack 1–3 / metafield packs
  $('.shopify-pack-dropdown .custom-dropdown-selected, .metafield-pack-dropdown .custom-dropdown-selected, .custom-select-wrapper .custom-dropdown:not(.disabled) .custom-dropdown-selected').each(function () {
    var text = ($(this).text() || '').replace(/\s+/g, ' ').trim();
    if (!text || text === '-- --') return;
    var key = normalizeInsidePackKey(text);
    if (key && selectedKeys.indexOf(key) === -1) selectedKeys.push(key);
  });
  if (window.bundleDropdownSelections) {
    Object.keys(window.bundleDropdownSelections).forEach(function (k) {
      var key = normalizeInsidePackKey(window.bundleDropdownSelections[k]);
      if (key && selectedKeys.indexOf(key) === -1) selectedKeys.push(key);
    });
  }
  if (window.metafieldPackSelections) {
    Object.keys(window.metafieldPackSelections).forEach(function (k) {
      var sel = window.metafieldPackSelections[k];
      if (!sel) return;
      var key = normalizeInsidePackKey(sel.title) || normalizeInsidePackKey(sel.productTitle);
      if (key && selectedKeys.indexOf(key) === -1) selectedKeys.push(key);
    });
  }
  return selectedKeys;
}

function sltFun(){
  setTimeout(function() {
    if (!$('.insd-pkg').length) return;

    var selectedKeys = getSelectedIncludedPackKeys();

    $('.insd-pkg .tab-list .tab-item, .insd-pkg .tab-content .tab').removeClass('sltTab active');

    // Base Unit stays available (black) even with no pack selected
    $('.insd-pkg .tab-list .tab-item, .insd-pkg .tab-content .tab').each(function(){
      var val = (($(this).attr('data-value') || '') + '').toLowerCase();
      if (val === 'base_unit' || selectedKeys.indexOf(val) !== -1) {
        $(this).addClass('sltTab');
      }
    });

    // Yellow active ONLY when at least one pack is selected above
    if (selectedKeys.length === 0) {
      $('.insd-pkg .tab-content .tab').each(function () {
        var val = (($(this).attr('data-value') || '') + '').toLowerCase();
        if (val === 'base_unit') $(this).addClass('active');
      });
      try {
        $('.insd-pkg .tab.active .sliderMain.slick-initialized').slick('refresh');
      } catch (e) {}
      return;
    }

    var focusKey = '';
    for (var i = 0; i < selectedKeys.length; i++) {
      var key = selectedKeys[i];
      var found = false;
      $('.insd-pkg .tab-list .tab-item').each(function () {
        if ((($(this).attr('data-value') || '') + '').toLowerCase() === key) found = true;
      });
      if (found) {
        focusKey = key;
        break;
      }
    }

    if (focusKey) {
      $('.insd-pkg .tab-list .tab-item, .insd-pkg .tab-content .tab').each(function(){
        var val = (($(this).attr('data-value') || '') + '').toLowerCase();
        if (val === focusKey) $(this).addClass('active');
      });
    }

    try {
      $('.insd-pkg .tab.active .sliderMain.slick-initialized, .insd-pkg .tab-content .tab.active .sliderMain.slick-initialized').slick('refresh');
    } catch (e) {}
  }, 150);
}

window.syncInsidePackageFromIncludedPacks = sltFun;

$(function () {
  sltFun();
  // Re-sync after late auto-select (complete bundle / URL params)
  setTimeout(sltFun, 400);
  setTimeout(sltFun, 1000);
});

$(document).on('click', '.boxTyp .typItem, #itemList .typItem', function () {
  sltFun();
});


//triggering the add to cart button onlick of the shop now.
// if($('*').hasClass('#sticky_prodBar')){  
//   let shopNowBtn = document.querySelector('#sticky_prodBar #priceBtn');
//   let addToCartBtn = document.querySelector('.product-form__buttons .adTcrt');
  
//   shopNowBtn.addEventListener('click', () => {
//     addToCartBtn.click();
//   });
// }

$('.imageFullWidth .mdl img').removeAttr('loading');




// video play button

  window.addEventListener('DOMContentLoaded', () => {
    let scrSz = window.innerWidth;
    let videoWrappers = document.querySelectorAll('.vdo-wpr');
    let index_1_heading = document.querySelector('#sec_hdng');
    let index_1_subheading = document.querySelector('#sec_subhdng');
    let rating_card = document.querySelector('.index1-container .rating__card');

    videoWrappers.forEach(wrapper => {
        let video = wrapper.querySelector('video');
        let playButton = wrapper.querySelector('.ply-btn');
        let isPlaying = false;
        

            // Play the video when the play button is clicked
            playButton.addEventListener('click', () => {
                video.play();
                playButton.style.display = 'none';
                index_1_heading.style.display = 'none';
                index_1_subheading.style.display = 'none';
                rating_card.style.display = 'none';
                isPlaying = true;
            });

            // Pause the video when it is clicked, and show the play button
            video.addEventListener('click', () => {
                if (isPlaying) {
                    video.pause();
                    playButton.style.display = 'block';
                   index_1_heading.style.display = 'block';
                    index_1_subheading.style.display = 'block';
                  rating_card.style.display = 'block';
                    isPlaying = false;
                }
            });

            // Update the flag and play button visibility when the video plays
            video.addEventListener('play', () => {
                isPlaying = true;
                playButton.style.display = 'none';
            });

            // Update the flag and play button visibility when the video pauses
            video.addEventListener('pause', () => {
                isPlaying = false;
                playButton.style.display = 'block';
            });
        
    });
});



// blog js
$('.sliderCrdArr').each(function(){
  var $this = $(this);
  $this.slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: $this.closest(".nws-tdy").find(".arrow-news-left"),
    nextArrow: $this.closest(".nws-tdy").find(".arrow-news-right"),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
});



// popup open for shipping text of product details page

$('.prd_bdg .bdg_gd .bdgicon').click(function(){
  $('.bdg_gd .popMsg').removeClass('showPop');
  $(this).parent().find('.popMsg').addClass('showPop');  
})

  $(".bdg_gd .popMsg .clsBnt").click(function(){
    $('.bdg_gd .popMsg').removeClass('showPop');    
  })
// End Popup



// for product variant alert
setTimeout(function(){  
$('.varientList li:not("#varientItem4")').click(function(event){
    
  var varientListOffset = $(this).closest('.varientList').offset(); // Get the offset of .varientList
  var cursorTopRelative = event.pageY - varientListOffset.top; // Calculate cursor top relative to .varientList
  cursorTopRelative = cursorTopRelative -70;
  cursorTopRelative = cursorTopRelative + "px";  
  
  $("#plsLt").css('top', cursorTopRelative);
  
  if(!$(this).hasClass('active')){       
    $(this).parent().find("#plsLt").show();    
    // hide after few second
    setTimeout(function(){    
    $("#plsLt").hide();    
    var offset = $('.prod-pack_wrapper').offset().top;
    // Smoothly scroll to the element's offset
    $('html, body').animate({
    scrollTop: offset    
    }, 100);  
  }, 2000);    
     
}  
  
});  
}, 1000);
//End aler



// testimonial slider
$('.tstmnls').each(function(){
  var $slider = $(this).find('.crd-wpr');
  var $prevArrow = $(this).find('.arrow-left');
  var $nextArrow = $(this).find('.arrow-right');

  // Initialize the slick slider for each .crd-wpr within its specific .tstmnls
  $slider.slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: $prevArrow,
    nextArrow: $nextArrow,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
});
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}
